__turbopack_context__.v({
  "ctaRow": "styles-module__Jr5BAa__ctaRow",
  "pill": "styles-module__Jr5BAa__pill",
  "pillOutline": "styles-module__Jr5BAa__pillOutline",
  "pillPrimary": "styles-module__Jr5BAa__pillPrimary",
  "pillUnderline": "styles-module__Jr5BAa__pillUnderline",
});
